module.exports = __webpack_public_path__ + "static/img/SB.9b8954f0.png";